import { FETCH_SITE_TYPES } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_SITE_TYPES:
			return action.payload;
		default:
			return state;
	}
};